import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const IsUserActive = (loginId, tenantName) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.LOGIN.IS_USER_ACTIVE(loginId, tenantName)
  );
};

export default IsUserActive;
